// src/pages/FoodItems.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const FoodItems = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(null);

  // Dummy data (replace with API data later)
  const categories = [
    {
      id: 1,
      name: "Pizza",
      subcategories: [
        { id: "veg-pizza", name: "Veg Pizza", image: "assets/images/foods/foods.png" },
        { id: "chicken-pizza", name: "Chicken Pizza", image: "assets/images/foods/foods.png" },
      ],
    },
    {
      id: 2,
      name: "Burgers",
      subcategories: [
        { id: "veg-burger", name: "Veg Burger", image: "assets/images/foods/foods.png" },
        { id: "cheese-burger", name: "Cheese Burger", image: "assets/images/foods/foods.png" },
      ],
    },
    {
      id: 3,
      name: "Drinks",
      subcategories: [
        { id: "soft-drinks", name: "Soft Drinks", image: "assets/images/foods/foods.png" },
        { id: "shakes", name: "Milk Shakes", image: "assets/images/foods/foods.png" },
      ],
    },
    {
      id: 4,
      name: "Desserts",
      subcategories: [
        { id: "ice-cream", name: "Ice Cream", image: "assets/images/foods/foods.png" },
        { id: "cake", name: "Cake", image: "assets/images/foods/foods.png" },
      ],
    },
  ];

  const handleSubcategoryClick = (subcategory) => {
   // navigate(`/items/${subcategory.id}`, { state: subcategory });
   navigate("/item", { state: { subcategory } });
  };

  const toggleCategory = (id) => {
    setActiveCategory(activeCategory === id ? null : id);
  };

  return (
    <main className="main-wrapper">
      <div className="main-content p-6">
        <h1 className="text-2xl font-bold mb-6">Food Categories</h1>

        {/* Categories in 3 per row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {categories.map((category) => (
            <div
              key={category.id}
              className="bg-white shadow rounded-lg p-4 border"
            >
              <div className="flex justify-between items-center mb-3">
                <p className="text-lg font-semibold bg-blue-200 text-grey rounded hover:bg-blue-600">{category.name}
                &nbsp;&nbsp;
                <button
                  className="text-sm px-3 py-1 bg-blue-100 text-grey rounded hover:bg-blue-300"
                  onClick={() => toggleCategory(category.id)}
                >
                  {activeCategory === category.id ? "▲" : "▼"}
                </button></p>
              </div>

              {/* Show subcategories only for active category */}
              {activeCategory === category.id && (
                <div className="grid grid-cols-2 gap-4">
                  {category.subcategories.map((sub) => (
                    <div
                      key={sub.id}
                      className="cursor-pointer bg-gray-50 rounded-lg shadow-sm hover:shadow-md transition"
                      onClick={() => handleSubcategoryClick(sub)}
                    >
                         <div className="p-2 text-left text-sm font-medium">
                      <img
                        src={sub.image}
                        alt={sub.name}
                        className="w-full h-24 object-cover rounded-t-lg"
                        style={{height:"60px",width:"auto"}}
                      />
                     &nbsp;&nbsp;
                        {sub.name}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default FoodItems;
